import React from 'react'
import Header from '../../components/header/Header';
import PageHeading from '../../components/pageHeading/PageHeading';
import Footer from '../../components/footer/Footer';
import { getFullName, twoDecimalPlaces } from '../../utils/common';

const JobDetailsServices = ({ details }) => {
  const fetchCharge = () => {
    if (details?.calculatedPrice) {
      return twoDecimalPlaces(details?.calculatedPrice);
    } else {
      if (details?.durationUpdated) {
        let price = details?.unitPrice * details?.durationUpdated;
        return twoDecimalPlaces(price);
      } else {
        let price = details?.unitPrice * details?.durationExpected;
        return twoDecimalPlaces(price);
      }
    }
  }
  const fetchTotal = () => {
    if (details?.finalPrice) {
      let price = details?.finalPrice ? twoDecimalPlaces(details?.finalPrice) : details?.finalPrice
      return price;
    } else {
      if (details?.durationUpdated) {
        let price = details?.unitPrice * details?.durationUpdated;
        let total = price + details?.taxAmount;
        return twoDecimalPlaces(total);
      } else {
        let price = details?.unitPrice * details?.durationExpected;
        let total = price + details?.taxAmount;
        return twoDecimalPlaces(total);
      }
    }
  }

  const getDuration = () => {
    if (details?.durationUpdated) {
      return `${twoDecimalPlaces(details?.durationUpdated)} Hr`;
    } else if (details?.durationExpected) {
      return `${twoDecimalPlaces(details?.durationExpected)} Hr`;
    } else {
      return 'NA'
    }
  }
  return (
    <>
      <Header />
      <PageHeading title="Job Details" />
      <div className='main-container'>
        {
          details ?
            <div className='container-wrap'>
              <div className='job-detail-wrapper'>
                <div className='job-content-wrapper'>
                  <h1>{getFullName(details?.userId?.firstName, details?.userId?.lastName)}</h1>
                  <p>{details?.userId?.email}</p>
                  <p>{details?.serviceId?.name}</p>
                  <h2>Job Description</h2>
                  <p>{details?.jobDetail}</p>

                  <div className='job-content-section'>
                    <div className='job-content-titile'>Payment Detail</div>
                    <div className='payment-detail-wrap'>
                      <table className='table'>
                        <tr>
                          <td width="800">Amount</td>
                          <td width="140">${fetchCharge()}</td>
                        </tr>
                        <tr>
                          <td>Time</td>
                          <td>{getDuration()}</td>
                        </tr>
                        <tr>
                          <td>Helpr app fee & Transaction fee</td>
                          <td>${twoDecimalPlaces(details?.taxAmount)}</td>
                        </tr>
                        <tr>
                          <td>Total</td>
                          <td>${fetchTotal()}</td>
                        </tr>
                      </table>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            :
            null
        }
      </div>
      <Footer />
    </>
  )
}

export default JobDetailsServices
